import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/break-even',
  component: () => import('../../routes/BreakEven.svelte'),
  card: {
    id: 'break-even',
    title: 'Break-Even Calculator',
    description: 'Find your break-even point in units and revenue. Enter fixed costs, variable costs, and pricing to plan profitability.',
    icon: 'balance',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/break-even',
    category: 'Business',
  },
  seo: {
    title: 'Break-Even Calculator – Break-Even Point & Contribution Margin Calculator',
    description: 'Free break-even calculator for businesses. Enter fixed costs, variable costs per unit, and selling price to find your break-even point in units and revenue. Includes contribution margin analysis, target profit planning, and visual break-even chart.',
  },
};

export default meta;
